import Vue from 'vue/dist/vue.js';
import auctionCountdown from './vueComponents/auctionCountdown.js';

Vue.config.productionTip = false;

export default {
    name      : 'results',
    _apiUrl   : null,
    _container: null,
    init() {
        this._container = document.querySelector('[data-results]');
        if (!this._container) {
            return;
        }

        const handle  = this._container.getAttribute('data-results');
        const baseUrl = this._container.getAttribute('data-base-url');
        const retailerId = this._container.getAttribute('data-retailer_id');
        this._apiUrl  = `${baseUrl}actions/tellus/${handle}/index`;

        if (typeof retailerId !== 'undefined' && ! isNaN(retailerId)) {
            this._apiUrl += '?retailer_id='+retailerId;
        }

        new Vue({
            el: this._container,
            delimiters: ['${', '}'],
            data: {
                // Generic config
                handle              : handle,
                apiUrl              : this._apiUrl,
                imageType           : 'front',      // 'front' = image of product, 'plan' = drawings of interior
                query               : '',           // search query in filters input
                queryTimeout        : null,         // is set while waiting for user to stop typing in search bar
                offset              : 0,            // offset of pagination (which page am I viewing)
                limit               : 18,           // amount of products to show per page
                pagesVisible        : 7,            // amount of pages visible at the same time in the pagination
                state               : 1,            // page number being set as we update history

                // Products
                products            : [],           // all products
                filteredProducts    : [],           // limited amount of products based on selected filters

                // List of all filter attributes on fetched products
                allBrands           : [],
                allTags             : [],
                allLocations        : [],
                allSalesforms       : [],
                allBerthTypes       : [],
                allCertificates     : [],
                allGearboxes        : [],
                allWheeldrives      : [],
                allProductTypes     : [],
                allFuels            : [],

                // Selected checkbox filter values
                selectedBrands      : [],
                selectedTags        : [],
                selectedLocations   : [],
                selectedSalesforms  : [],
                selectedBerthTypes  : [],
                selectedCertificates: [],
                selectedGearboxes   : [],
                selectedWheeldrives : [],
                selectedProductTypes: [],
                selectedFuels       : [],


                // available chechboxes
                availableSalesforms  : [],
                availableBerthTypes  : [],

                // "From - to" filter values
                price               : {from: null, to: null},
                distance            : {from: null, to: null},
                year                : {from: null, to: null},
                weight              : {from: null, to: null},
                beds                : {from: null, to: null},
                seats               : {from: null, to: null},
                horsepower          : {from: null, to: null},
                carryWeight         : {from: null, to: null},
                length              : {from: null, to: null},

                // If there are more than 7 checkboxes, a show more link is displayed. These booleanss handle the toggle
                showAllFilters      : false,
                showAllBrands       : false,
                showAllLocations    : false,
                showAllSalesforms   : false,
                showAllBerthTypes   : false,
                showAllCertificates : false,
                showAllGearboxes    : false,
                showAllWheeldrives  : false,
                showAllProductTypes : false,
                showAllFuels        : false,

                // Top right filters
                campaign            : false,        // only show campaign products
                listType            : 'board',      // 'board' is a grid view of product, 'list' is one product per line
                sortDir             : 'descDate',   // how to sort the products, default 'descDate' is new to old
                sortList            : false,        // toggle the sorting options popup modal

                // Data for condensing functions
                checkboxes: [
                    {name: 'Tags',         key: 'tgs', value: false, cert: false},
                    {name: 'Brands',       key: 'br', value: false, cert: false},
                    {name: 'Locations',    key: 'rl', value: false, cert: false},
                    {name: 'Salesforms',   key: 'sf', value: false, cert: false},
                    {name: 'BerthTypes',   key: 'bts', value: false, cert: false},
                    {name: 'Certificates', key: 'wt', value: false, cert: true },
                    {name: 'Gearboxes',    key: 'tr', value: true,  cert: false},
                    {name: 'Wheeldrives',  key: 'wd', value: true,  cert: false},
                    {name: 'ProductTypes', key: 'pt', value: false, cert: false},
                    {name: 'Fuels',        key: 'f',  value: false, cert: false},
                ],

                fromTos: [
                    {name: 'price',       key: 'p',  value: false},
                    {name: 'distance',    key: 'm',  value: false},
                    {name: 'year',        key: 'y',  value: false},
                    {name: 'weight',      key: 'w',  value: false},
                    {name: 'beds',        key: 'b',  value: false},
                    {name: 'seats',       key: 's',  value: true },
                    {name: 'horsepower',  key: 'hp', value: false},
                    {name: 'carryWeight', key: 'py', value: true },
                    {name: 'length',      key: 'l',  value: false},
                ]
            },
            created() {
                this.fetchProducts();
                this.setPredefinedFilters();
                window.onpopstate = (event) => {
                    this.resetFilters();
                    this.queryParams();
                    this.update(true);
                }
            },
            methods: {
                getCampaignTag(product)
                {
                    return (typeof product.tgs === 'string' && product.tgs.length) ?
                         product.tgs : '';
                },

                getPriceDifference(product)
                {
                    return (product.bp > product.p) ?
                         ` spar ` + this.formatNumber(product.bp - product.p) + `  `+ this.formatCurrency(product) : '';
                },

                setPredefinedFilters()
                {
                    const container = document.querySelector('[data-results]');

                    if (container && typeof container.dataset.filters === 'string' && container.dataset.filters.length) {
                        const filters = JSON.parse(container.dataset.filters);
                        for (let filter in filters) {
                            this[filter].push(filters[filter])
                        }
                    }
                },
                toggleFilters() {
                    const body = document.querySelector('body');
                    body.classList.toggle("no-scroll");

                    const filters = document.querySelector('.filters');
                    filters.classList.toggle("filters--active");
                },
                fetchProducts() {
                    const request = new XMLHttpRequest();
                    request.addEventListener('load', () => {
                        if (request.readyState === 4 && request.status === 200) {
                            this.products = JSON.parse(request.responseText);
                            this.products.forEach((p) => {
                                p.discount = (p.bp) ? parseInt(p.bp) - parseInt(p.p) : 0;
                            });

                            
                            this.makeFilters();
                            this.queryParams(); // get filters from queryParams
                            this.update();
                        }
                    });

                    request.open('GET', this.apiUrl);
                    request.send();
                },
                makeFilters() {
                    this.allBrands       = this.getFilters('br');
                    this.allTags         = this.getFilters('tgs');
                    this.allLocations    = this.getFilters('rl');
                    this.allSalesforms   = this.getFilters('sf');
                    this.allBerthTypes   = this.getMultiFilters('bts');
                    this.allCertificates = this.getFilters('w',  false, true);
                    this.allGearboxes    = this.getFilters('tr', true);
                    this.allWheeldrives  = this.getFilters('wd', true);
                    this.allProductTypes = this.getFilters('pt');
                    this.allFuels        = this.getFilters('f');
                },
                resetFilters() {
                    this.query                = '',
                    this.campaign             = false,
                    this.listType             = 'board',
                    this.sortDir              = 'descDate',
                    this.sortList             = false,
                    this.selectedBrands       = [];
                    this.selectedTags         = [];
                    this.selectedLocations    = [];
                    this.selectedSalesforms   = [];
                    this.selectedCertificates = [];
                    this.selectedGearboxes    = [];
                    this.selectedWheeldrives  = [];
                    this.selectedProductTypes = [];
                    this.selectedFuels        = [];
                    this.price       = {from: null, to: null};
                    this.distance    = {from: null, to: null};
                    this.year        = {from: null, to: null};
                    this.weight      = {from: null, to: null};
                    this.beds        = {from: null, to: null};
                    this.seats       = {from: null, to: null};
                    this.horsepower  = {from: null, to: null};
                    this.carryWeight = {from: null, to: null};
                    this.length      = {from: null, to: null};
                },
                getFilters(key, value = false, cert = false) {
                    const items = [];
                    for (const product of this.products) {
                        if (!product[key] || (value ? !product[key].value : false)) {
                            continue;
                        }
                        let filterValue = value ? product[key].value               : product[key];
                            filterValue = cert  ? this.getCertificate(filterValue) : filterValue;

                        if (items.indexOf(filterValue) === -1) {
                            items.push(filterValue);
                        }
                    }

                    return items;
                },
                getMultiFilters(key) {
                    const items = new Set();

                    for (const product of this.products) {
                        if (typeof product[key] !== 'object') {
                            continue;
                        }

                        product[key].forEach((i) => {
                            if (typeof i === 'string' && i.length) {
                                items.add(i)
                            }
                        });
                    }

                    return items;
                },
                queryParams(location = undefined) {
                    const urlSearchParams = new URLSearchParams(location ? location.search : window.location.search);
                    const params = Object.fromEntries(urlSearchParams.entries());
                    for (const key in params) {
                        let element = params[key];
                        if (element.charAt(0) === '[') {
                            element = JSON.parse(element);
                        } else if (element.includes(',')) {
                            element = element.split(',');
                        }

                        // i.e priceFrom=1000000
                        if (key.includes('From')) {
                            const name      = key.replace('From', '');
                            this[name].from = parseInt(element);

                        // i.e priceTo=1000000
                        } else if (key.includes('To')) {
                            const name    = key.replace('To', '');
                            this[name].to = parseInt(element);

                        } else if (key === 'search') {
                            this.query = element;
                        } else if (key === 'c') {
                            this.campaign = true;
                        } else if (key === 'list') {
                            this.listType = 'list';
                        } else if (key === 'sort') {
                            this.sortDir = element;

                        // i.e br=['Hymer','Bürstner']
                        } else if (Array.isArray(element)) {
                            const name = this.getCheckboxName(key)
                            if (name) {
                                for (const el of element) {
                                    if (this['selected' + name].indexOf(el) === -1) {
                                        this['selected' + name].push(el);
                                    }
                                }
                            }
                        // i.e br=Hymer
                        } else {
                            const name = this.getCheckboxName(key)
                            if (name && this['selected' + name].indexOf(element) === -1) {
                                this['selected' + name].push(element);
                            }
                        }
                    }
                },
                updateQueryParams() {
                    let params = '?';
                    if (this.query) {
                        params += 'search=' + this.query;
                    }
                    // if (this.tags) {
                    //     params += params !== '?' ? '&' : '';
                    //     params += 'tgs='.+;
                    // }
                    if (this.listType !== 'board') {
                        params += params !== '?' ? '&' : '';
                        params += 'list=true';
                    }
                    if (this.sortDir !== 'descDate') {
                        params += params !== '?' ? '&' : '';
                        params += 'sort=' + this.sortDir;
                    }
                    for (const checkbox of this.checkboxes) {
                        if (this['selected' + checkbox.name].length) {
                            params += params !== '?' ? '&' : '';
                            params += checkbox.key + '=' + this['selected' + checkbox.name].join(',');
                        }
                    }
                    for (const fromTo of this.fromTos) {
                        if (this[fromTo.name].from) {
                            params += params !== '?' ? '&' : '';
                            params += fromTo.name + 'From=' + this[fromTo.name].from;
                        }
                        if (this[fromTo.name].to) {
                            params += params !== '?' ? '&' : '';
                            params += fromTo.name + 'To=' + this[fromTo.name].to;
                        }
                    }

                    history.pushState({page: this.state}, this.handle, params);
                    this.state++;
                },
                checkAll(id)
                {
                    const all = 'all'+id;
                    const selected = 'selected'+id;

                    this[selected] = (this[all].length > 0 && this[selected].length !== this[all].length) ?
                        this[all] :
                        [] ;

                    this.update();
                },
                updateSelected(key, value)
                {
                    if (this['selected' + key].indexOf(value) === -1) {
                        this['selected' + key].push(value);
                    } else {
                        this['selected' + key] = this['selected' + key].filter(item => item !== value);
                    }

                    this.update();
                },
                updateFilteredProducts()
                {
                    let filtered = this.products.slice();
                        filtered = this.matchesCheckboxes(filtered);
                        filtered = this.matchesFromTos(filtered);
                        filtered = this.matchesSearch(filtered);
                        filtered = this.sortProducts(filtered);

                    // if (this.campaign) { filtered = filtered.filter(i => i.c); }
                    // temporary hack
                    if (this.campaign) {
                        filtered = filtered.filter(i => {
                            let modelDesc = (typeof i.ms === 'string') ? i.ms.toLowerCase() : '';
                            let series = (typeof i.pl === 'string') ? i.pl.toLowerCase() : '';
                            let title = (typeof i.t === 'string') ? i.t.toLowerCase() : '';
                            let hack1 = modelDesc.includes('%') || modelDesc.includes('kampanje') || modelDesc.includes('rente') || modelDesc.includes('finansiering');
                            let hack2 = series.includes('%') || series.includes('kampanje') || series.includes('rente') || series.includes('finansiering');
                            let hack3 = title.includes('%') || title.includes('kampanje') || title.includes('rente') || title.includes('finansiering');

                            return (i.c || hack1 || hack2 || hack3);
                        });
                    }

                    this.filteredProducts = filtered;
                },
                updateSearch() {
                    if (this.queryTimeout) {
                        clearTimeout(this.queryTimeout);
                    }

                    this.queryTimeout = setTimeout(() => {
                        this.update();
                    }, 500);
                },
                update(popstate) {
                    this.updateFilteredProducts();

                    // close sorting popup if open
                    if (this.sortList) {
                        this.toggle('sortList');
                    }

                    if (!popstate) {
                        this.updateQueryParams(popstate);
                    }

                    // go to page 1 of pagination
                    this.offset = 0;
                },
                matchesSearch(products) {
                    const search = this.formatString(this.query);

                    let filtered = products;
                    if (search) {
                        filtered = filtered.filter(i => {
                            const t    = i.t   ? i.t   : '';
                            const des  = i.html ? i.html : '';

                            return this.formatString(t).includes(search)   ||
                                   this.formatString(des).includes(search) ||
                                   search === i.y                          ||
                                   search === i.pt.toLowerCase()           ||
                                   search === i.sf.toLowerCase();
                        });
                    }

                    return filtered;
                },
                matchesFromTos(products) {
                    let filtered = products;
                    for (const item of this.fromTos) {
                        const from = this[item.name].from ? parseInt(this[item.name].from) : null;
                        const to   = this[item.name].to   ? parseInt(this[item.name].to)   : null;

                        if (!from && !to) {
                            continue;
                        }

                        filtered = filtered.filter(i => {
                            const value = parseInt(item.value  ? i[item.key].value : i[item.key]);

                            if (from && to) {
                                return value >= from && value <= to;
                            } else if (from) {
                                return value >= from;
                            } else if (to) {
                                return value <= to;
                            }

                            return true;
                        });
                    }

                    return filtered;
                },
                matchesCheckboxes(products, brands = true) {
                    let filtered = products;

                    for (const checkbox of this.checkboxes) {
                        if (! this.isLoggedIn() && checkbox.name === 'Salesforms' && this.selectedSalesforms.length === 0 && this.availableSalesforms.length > 0) {
                            this.selectedSalesforms = this.availableSalesforms.map(sf => sf.t);
                        }

                        // loop each checkbox wtih selected options
                        // if (this['selected' + checkbox.name].length && (brands ? true : checkbox.name !== 'Brands')) { // <== maybe deprecated ???
                        if (this['selected' + checkbox.name].length) {
                            // filter each product
                            filtered = filtered.filter(i => {
                                // key = checkbox value
                                let key = checkbox.value ?
                                    i[checkbox.key].value :
                                    i[checkbox.key];
                                // exception for certificates
                                key = checkbox.cert ? this.getCertificate(key) : key;

                                // temporary exception for berth types
                                if (checkbox.key === 'bts') {
                                    let tmp = Object.values(i[checkbox.key]);
                                    return this.selectedBerthTypes.some((element) => tmp.includes(element));
                                    // default scenario
                                } else {
                                    return this.inSelected(checkbox.name, key);
                                }
                            });
                        }
                    }

                    return filtered;
                },
                inSelected(key, value) {
                    return this['selected' + key].indexOf(value) !== -1;
                },
                toggle(item) {
                    this[item] = !this[item];
                },
                sort(dir) {
                    this.sortDir = dir;
                    this.update();
                },
                sortProducts(products) {
                    let filtered = products;
                        filtered = this.sortDir === 'descDate'  ? products : filtered;
                        filtered = this.sortDir === 'ascDate'   ? filtered.reverse() : filtered;
                        filtered = this.sortDir === 'ascYear'   ? filtered.sort((a, b) => a.y - b.y) : filtered;
                        filtered = this.sortDir === 'descYear'  ? filtered.sort((a, b) => b.y - a.y) : filtered;
                        filtered = this.sortDir === 'descBrand' ? filtered.sort((a,b) => {
                            if (a.br < b.br) { return -1; }
                            if (a.br > b.br) { return  1; }
                            return 0;
                        }) : filtered;
                        filtered = this.sortDir === 'ascBrand' ? filtered.sort((a,b) => {
                            if (a.br > b.br) { return -1; }
                            if (a.br < b.br) { return  1; }
                            return 0;
                        }) : filtered;
                        filtered = this.sortDir === 'descPrice' ? filtered.sort((a, b) => {
                            let totalA = a.p;
                                totalA = parseInt(a.re) > 0 ? totalA + parseInt(a.re) : totalA;
                            let totalB = b.p;
                                totalB = parseInt(b.re) > 0 ? totalB + parseInt(b.re) : totalB;

                            return totalA - totalB;
                        }) : filtered;
                        filtered = this.sortDir === 'ascPrice' ? filtered.sort((a, b) => {
                            let totalA = a.p;
                                totalA = parseInt(a.re) > 0 ? totalA + parseInt(a.re) : totalA;
                            let totalB = b.p;
                                totalB = parseInt(b.re) > 0 ? totalB + parseInt(b.re) : totalB;

                            return totalB - totalA;
                        }) : filtered;

                        filtered = this.sortDir === 'descDiscount' ? filtered.sort((a, b) => {
                            return b.discount - a.discount;
                        }) : filtered;

                    return filtered;
                },
                goTo(index) {
                    window.scrollTo(0,0);
                    this.offset = index;
                },
                getCheckboxName(key) {
                    for (const item of this.checkboxes) {
                        if (item.key === key) {
                            return item.name;
                        }
                    }

                    return '';
                },
                formatNumber(weight) {
                    return parseInt(weight).toLocaleString('no');
                },
                getModel(product) {
                    const title = product.t.replace(product.br + ' ', '');

                    return title.charAt(0).toUpperCase() + title.slice(1);
                },
                getImageUrl(productImageUrl) {
                    return `${productImageUrl}`;
                },
                formatString(string) {
                    return string.split(' ').join('').toLowerCase();
                },
                hasFrontImageType(product) {
                    return this.imageType === "front" && product.id && product.i ||
                           this.imageType === "plan"  && product.i;
                },
                hasPlanImageType(product) {
                    return this.imageType === "plan" && product.id && product.fp;
                },
                getCertificate(weight) {
                    return weight <= 3500 ? 'Klasse B' : 'Klasse C1';
                },

                formatCurrency(item)
                {
                    return (typeof item.cur === 'string' && item.cur.length && item.cur !== 'NOK') ?
                        item.cur : 'kr.';
                },

                formatPrice(price, regCost = 0) {
                    let total = price;
                        total = parseInt(regCost) > 0 ? total + parseInt(regCost) : total;

                    return total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                },
                filterUrl(product) {
                    let url = product.u;

                    if (product.sf === 'Auksjon') {
                        url = 'https://outlet.tellus.no/' + url;
                    }

                    return url;
                },
                isLoggedIn() {
                    // const domain = document.location.host;
                    // return domain.includes('outlet');
                    // return Cookies.get('ma_session');

                    return true;
                },
                formateDate (value)
                {
                    const date = new Date(value)
                    return dateFormat(date, "dd mmm HH:MM");
                },
            },
            computed: {
                brands() {
                    let brands = [];
                    for (const brand of this.allBrands) {
                        let filtered = this.products;
                            filtered = this.matchesCheckboxes(filtered, false);
                            filtered = this.matchesFromTos(filtered);
                            filtered = this.matchesSearch(filtered);

                        brands.push({
                            t: brand,
                            a: filtered.filter(item => item.br === brand).length
                        });
                    }
                    brands = brands.sort((a, b) => b.a - a.a);

                    return brands.slice(0, this.showAllBrands ? brands.length : 7);
                },
                tags() {
                    let tags = [];
                    for (const tag of this.allTags) {
                        let filtered = this.products;
                            filtered = this.matchesCheckboxes(filtered, false, 'tags');
                            filtered = this.matchesFromTos(filtered);
                            filtered = this.matchesSearch(filtered);

                        tags.push({
                            t: tag,
                            a: filtered.filter(item => item.tgs === tag).length
                        });
                    }
                    // tags = tags.sort((a, b) => b.a - a.a);

                    return tags.slice(0, this.showAllTags ? tags.length : 7);
                },
                locations() {
                    const locations = [];
                    for (const location of this.allLocations) {
                        let filtered = this.products;
                            filtered = this.matchesCheckboxes(filtered);
                            filtered = this.matchesFromTos(filtered);
                            filtered = this.matchesSearch(filtered);

                        if (this.products.filter(item => item.rl === location).length) {
                            locations.push({
                                t: location,
                                a: filtered.filter(item => item.rl === location).length
                            });
                        }
                    }

                    return locations.slice(0, this.showAllLocations ? locations.length : 7);
                },
                salesforms() {
                    const salesforms = [];

                    for (const salesform of this.allSalesforms) {
                        if (salesform !== 'Auksjon' || salesform === 'Auksjon' && this.isLoggedIn()) {
                            if (this.products.filter(item => item.sf).length) {
                                salesforms.push({t: salesform});
                            }
                        }
                    }

                    this.availableSalesforms = salesforms.slice(0, this.showAllSalesforms ? salesforms.length : 7);

                    return this.availableSalesforms;
                },
                berthTypes() {
                    const berthTypes = [];

                    for (const berthType of this.allBerthTypes) {
                        berthTypes.push({t: berthType});
                    }

                    this.availableBerthTypes = berthTypes.slice(0, this.showAllBerthTypes ? berthTypes.length : 7);

                    return this.availableBerthTypes;
                },
                certificates() {
                    const certs = [];
                    for (const cert of this.allCertificates) {
                        if (this.products.filter(item => this.getCertificate(item.w) === cert).length) {
                            certs.push({t: cert});
                        }
                    }

                    return certs.slice(0, this.showAllCertificates ? certs.length : 7);
                },
                gearboxes() {
                    const gearboxes = [];
                    for (const gearbox of this.allGearboxes) {
                        if (this.products.filter(item => (item.tr ? item.tr.value : '') === gearbox).length) {
                            gearboxes.push({t: gearbox});
                        }
                    }

                    return gearboxes.slice(0, this.showAllGearboxes ? gearboxes.length : 7);
                },
                wheeldrives() {
                    const wheeldrives = [];
                    for (const wheeldrive of this.allWheeldrives) {
                        if (this.products.filter(item => (item.wd ? item.wd.value : '') === wheeldrive).length) {
                            wheeldrives.push({t: wheeldrive});
                        }
                    }

                    return wheeldrives.slice(0, this.showAllWheeldrives ? wheeldrives.length : 7);
                },
                productTypes() {
                    const productTypes = [];
                    for (const productType of this.allProductTypes) {
                        if (this.products.filter(item => item.pt === productType).length) {
                            productTypes.push({t: productType});
                        }
                    }

                    return productTypes.slice(0, this.showAllProductTypes ? productTypes.length : 7);
                },
                fuels() {
                    const fuels = [];
                    for (const fuel of this.allFuels) {
                        if (this.products.filter(item => item.f === fuel).length) {
                            fuels.push({t: fuel});
                        }
                    }

                    return fuels.slice(0, this.showAllFuels ? fuels.length : 7);
                },
                paginatedProducts() {
                    const currentPage = this.offset * this.limit;
                    return this.filteredProducts.slice(currentPage, currentPage + this.limit);
                },
                pages() {
                    if (!this.filteredProducts.length) {
                        return [];
                    }

                    // Array from 0 to n pages [0, 1, 2, ..., n]
                    const arr = [...Array(Math.ceil(this.filteredProducts.length / this.limit)).keys()];

                    if (arr.length < 7) {
                        return arr;
                    }

                    // Show the same amount of pages before and after the selected page
                    const eitherSide = Math.floor(this.pagesVisible / 2);

                    const length = arr.length;
                    const left   = this.offset - eitherSide > 0 ? this.offset - eitherSide : 0;
                    const limit  = length - this.pagesVisible;

                    const start  = left  > limit ? limit : left;
                    const end    = start + this.pagesVisible;

                    return arr.slice(start, end);
                }
            }
        });
    }
}